import { render, staticRenderFns } from "./BlogPartial.htm?vue&type=template&id=4e0888a4&scoped=true&external"
import script from "./BlogPartial.js?vue&type=script&lang=js&external"
export * from "./BlogPartial.js?vue&type=script&lang=js&external"
import style0 from "./BlogPartial.scss?vue&type=style&index=0&id=4e0888a4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0888a4",
  null
  
)

export default component.exports